export default function Dropdown({ label, options, selected, onChange }) {
  return (
    <div className="dropdown-container">
      <label>{label}</label>
      <select value={selected} onChange={onChange}>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}
